import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import triangle from "../../images/triangle.svg";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";
import moment from "moment";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../helpers/common";
import { generateCrateCreditPdf } from "../Pdfs/CrateCredit";

const CrateCredit = () => {
    const navigate = useNavigate();
    const creditDetailObj = {
        Qty: '',
        ContainerID: '',
        CrateCreditAmt: '',
        CrateReturnValue: '',
        CrateReturnGST: 0
    }
    const [errors, setErrors] = useState({});
    const [creditDetails, setCreditDetails] = useState([creditDetailObj]);
    const [crates, setCrates] = useState([]);
    const [customerDetailsObj, setCustomerDetailsObj] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [returnDate, setReturnDate] = useState(moment().format('YYYY-MM-DD'));
    const [reference, setReference] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [focusIndex, setFocusIndex] = useState(0);
    const [focusEndIndex, setFocusEndIndex] = useState(null);
    const [customeCodeErr, setCustomeCodeErr] = useState(false);
    const [referenceErr, setreferenceErr] = useState(false);
    const { user } = useAuth();
    const creditInputRefs = useRef([]);
    const creditEndInputRefs = useRef([]);

    useEffect(() => {
        var headerHeight = $("header").outerHeight();
        var mainHeight = $(window).height() - headerHeight;
        $("main").height(mainHeight);
        $("main").css("margin-top", headerHeight + "px");

        var tableRow = ".table-form tbody > tr";

        $(tableRow).on("focusin", function () {
            $(this).addClass("focus-tr");
        });

        $(tableRow).on("focusout", function () {
            $(this).removeClass("focus-tr");
        });
    });

    useEffect(() => {
        const fetchData = async () => {
            let userURL = process.env.REACT_APP_API_URL + "/search-customer";
            let containersURL = process.env.REACT_APP_API_URL + "/get-all-containers";
            let customersResponse = await GETREQUEST(userURL, user.jwtToken);
            let cratesResponse = await GETREQUEST(containersURL, user.jwtToken);

            if (customersResponse?.data) {
                let ccList = [];
                customersResponse.data.forEach((item) => {
                    ccList = [...ccList, { label: item.CustomerCode, value: item.value, ...item }];
                });
                setCustomers(ccList);
            }

            if (cratesResponse?.data) {
                let containersList = [];
                cratesResponse.data.forEach((item) => {
                    containersList = [...containersList, { label: item.TypeInCode, value: item.ContainerID, ...item }];
                });

                containersList.sort((a, b) => {
                    const numA = parseInt(a.label);
                    const numB = parseInt(b.label);

                    if (!isNaN(numA) && !isNaN(numB)) {
                        return numA - numB;
                    } else if (!isNaN(numA)) {
                        return -1;
                    } else if (!isNaN(numB)) {
                        return 1;
                    } else {
                        return a.TypeInCode.localeCompare(b.TypeInCode);
                    }
                });
                setCrates(containersList)
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (focusIndex && creditInputRefs.current[focusIndex]) {
            creditInputRefs.current[focusIndex].focus();
        }
    }, [focusIndex]);

    useEffect(() => {
        if (focusEndIndex != null && creditEndInputRefs.current[focusEndIndex]) {
            creditEndInputRefs.current[focusEndIndex].focus();
        }
    }, [focusEndIndex]);

    const getReference = async () => {
        let refURL = process.env.REACT_APP_API_URL + "/get-crate-creditnote-ref";
        let response = await GETREQUEST(refURL, user.jwtToken, false);
        if (response?.data) {
            setReference(response.data.CNReference.toString());
            setreferenceErr(false);
        }
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: "gray",
            backgroundColor: state.isSelected ? "#01B1E3" : "#fff",
            zIndex: 9999,
        }),
    };

    const CustomOption = (props) => {
        return (
            <div
                className=""
                style={{
                    background: props.isFocused
                        ? '#01B1E3'
                        : props.isSelected
                            ? 'rgb(54, 179, 126)'
                            : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
                }}
                {...props.innerProps}
                ref={props.innerRef}
            >
                {props.label}
            </div>
        )
    }

    const handleCrateChange = (e, index) => {
        let CrateCreditAmt = creditDetails[index].Qty * e.ReturnValue;
        setCreditDetails(prevCrateDetails => {
            const updatedCrateDetails = [...prevCrateDetails];
            updatedCrateDetails[index].ContainerID = e.value;
            updatedCrateDetails[index].CrateCreditAmt = addTrailingZeros(CrateCreditAmt);
            updatedCrateDetails[index].CrateReturnValue = e.ReturnValue;
            return updatedCrateDetails;
        });
    }

    const calculateTotalCredit = () => {
        let total = 0;
        creditDetails.map((credit) => {
            let value = credit.CrateCreditAmt;
            if (value)
                total += parseFloat(value);
        });
        return total ? total.toFixed(2) : 0.00
    }

    const checkError = (value, index, field) => {
        if (index < creditDetails.length - 1) {
            if (!value) {
                setErrors((prevData) => ({
                    ...prevData,
                    [field + index]: true
                }));
            } else {
                setErrors((prevData) => {
                    const updatedError = { ...prevData };
                    delete updatedError[field + index];
                    return updatedError;
                });
            }
        }
    };

    const checkRows = (index) => {
        const fields = ['Qty', 'ContainerID', 'CrateCreditAmt'];
        let returnValue = false;
        if (creditDetails.length === 1 || Object.keys(errors).length === 0) {
            fields.map((field) => {
                let value = creditDetails[index][field]
                if (!value) {
                    setErrors((prevData) => ({
                        ...prevData,
                        [field + index]: true
                    }));
                    returnValue = true
                } else {
                    setErrors((prevData) => {
                        const updatedError = { ...prevData };
                        delete updatedError[field + index];
                        return updatedError;
                    });
                    returnValue = false
                }
            });
        }
        return returnValue;
    }

    const addNewRow = (index) => {
        const isErrors = checkRows(index);
        if (isErrors) {
            setFocusEndIndex(index);
        }
        if (creditDetails.length - 1 == index && Object.keys(errors).length === 0) {
            setCreditDetails(prevCrateDetails => {
                const updatedCrateDetails = [...prevCrateDetails, creditDetailObj];
                return updatedCrateDetails;
            });
            setFocusIndex(index + 1)
        }
    }

    const handleDelete = (index) => {
        let creditD = creditDetails.filter((a, i) => index !== i);
        setCreditDetails(creditD);
    };

    const handleSave = async() => {
        if (validateForm()) {
            let updatedCrateDetails = [];
            creditDetails.map((creditItem) => {
                if (creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== '') {
                    updatedCrateDetails.push({
                        ...creditItem,
                        CrateCreditAmt: creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt).toFixed(2) : 0
                    })
                }
            })
            let payload = {
                CustomerID: customerDetailsObj?.CustomerID,
                ReturnDate: returnDate,
                ReferenceNo: reference,
                creditDetails: updatedCrateDetails
            }
            let saveURL = process.env.REACT_APP_API_URL + "/create-crate-credit-note";
            setMessage('')
            setMessageType('')
            let response = await POSTREQUEST(saveURL, payload, user.jwtToken);
            if(response?.data){
                if (response.data.success) {
                    setMessage(response.data.message);
                    setMessageType('success');
                    navigate(`/view-edit-crate-credit/${response.data.CNID}`)
                } else {
                    setMessage(response.data.message);
                    setMessageType('error');
                }
            }else{
                setMessage(response?.error?.message || 'Failed to create crate credit !!');
                setMessageType('error');
            }
        }
    }

    const validateForm = () => {
        if (customerDetailsObj === null) {
            setCustomeCodeErr(true);
        }
        // if (reference == "") {
        //     setreferenceErr(true);
        // }
        if (Object.keys(errors).length !== 0 || customerDetailsObj === null) {
            return false;
        }
        else {
            return true
        }
    }

    const handlePreview = () => {
        let updatedCrateDetails = [];
        creditDetails.map((creditItem) => {
            if (creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== '') {
                updatedCrateDetails.push({
                    ...creditItem,
                    CrateCreditAmt: creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt).toFixed(2) : 0
                })
            }
        })
        let previewData = {
            CNID: "",
            ReturnDate: returnDate,
            ReferenceNo: reference,
            tblCustomer: customerDetailsObj,
            crates,
            creditDetails: updatedCrateDetails
        }
        generateCrateCreditPdf(previewData);
    }

    return (
        <React.Fragment>
            <Header />
            {message && <Toastify message={message} type={messageType} />}
            <main className="bg-lite-grey overflow-auto">
                <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
                    <div className="table-elements">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item fs-15">
                                    <Link
                                        to="/all-orders"
                                        className="text-decoration-none text-primary"
                                    >
                                        Credit
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item fs-15 active"
                                    aria-current="page"
                                >
                                    Crate Credit
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="card border-bottom-0">
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
                            <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                                Enter Crate Credit
                            </h1>
                            <div className="filter-elements d-flex align-items-center">
                                <div className="custom-group flex-nowrap mb-xl-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Code:
                                    </label>
                                    <div className="date position-relative cme-15">
                                        <Select
                                            className={`${customeCodeErr ? 'react-select-invalid' : ''} `}
                                            value={customerDetailsObj}
                                            isSearchable={true}
                                            styles={customStyles}
                                            options={customers}
                                            placeholder="Select Code"
                                            onChange={(e) => { setCustomerDetailsObj(e); setCustomeCodeErr(false) }}
                                            components={{ Option: CustomOption }}
                                        />
                                    </div>
                                </div>

                                <div className="custom-group flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Return date:
                                    </label>
                                    <div className="position-relative cme-12" data-provide="datepicker">
                                        <input
                                            type="date"
                                            id="datepicker"
                                            className="form-control input-sm date input-datepicker"
                                            placeholder="Select Date"
                                            defaultValue={returnDate}
                                            onChange={(e) => {
                                                setReturnDate(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="custom-group flex-nowrap mb-lg-0 pe-3">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Credit No:
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control input-sm input-width-180`}
                                        disabled
                                    />
                                </div>

                                <div className="custom-group flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Reference:
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control input-sm input-width-180 ${referenceErr ? 'is-invalid' : ''}`}
                                        value={reference}
                                        onChange={(e) => {
                                            setReference(e.target.value);
                                            setreferenceErr(false)
                                        }}
                                    />
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 flex-nowrap">
                            <div className="filter-elements d-flex align-items-center justify-content-around w-100">
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Buyer Code
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.BuyerCode}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Customer Code
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerCode}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Customer Contact
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerContact}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Phone Number
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerContact}
                                    />
                                </div>
                                <div className="flex-nowrap mb-lg-0">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Fax Number:
                                    </label>
                                    <input type="text"
                                        className="form-control input-sm"
                                        value={customerDetailsObj?.CustomerContact}
                                    />
                                </div>
                            </div>
                            <div></div>
                        </div>

                        <div className="card-body p-4 border-bottom">

                            <div className="card-table table-responsive">
                                <table className="table table-form disable-field">
                                    <thead>
                                        <tr>
                                            <td scope="col" className="width-lg-1"></td>
                                            <td scope="col" className="width-lg-4">
                                                Qty
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Crate
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Crate Credit
                                            </td>
                                            <td scope="col" className="width-lg-1"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {creditDetails.length > 0 && creditDetails.map((creditDetailItem, index) => {
                                            return (<tr key={index + 1} className="custom-space">
                                                <td valign="middle">
                                                    <img src={triangle} className="indicator" alt="" />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className={`form-control input-sm text-end input-width-90 ${errors[`Qty` + index] ? "is-invalid" : ''}`}
                                                        placeholder="Qty"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevCrateDetails => {
                                                                const updatedCrateDetails = [...prevCrateDetails];
                                                                updatedCrateDetails[index].Qty = e.target.value;
                                                                updatedCrateDetails[index].CrateCreditAmt = e.target.value * (crates.find(crate => crate.ContainerID === updatedCrateDetails[index].ContainerID))?.ReturnValue;
                                                                return updatedCrateDetails;
                                                            });
                                                        }}
                                                        value={creditDetailItem.Qty}
                                                        ref={el => creditInputRefs.current[index] = el}
                                                        onBlur={(e) => checkError(e.target.value, index, 'Qty')}
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        className={`input-sm input-width-90 ${errors[`ContainerID` + index] ? "react-select-invalid" : ''}`}
                                                        defaultValue={"Select Crate"}
                                                        value={crates.find(crate => crate.ContainerID == creditDetailItem.ContainerID) || ''}
                                                        options={crates}
                                                        placeholder="Select Crate"
                                                        onChange={(e) => handleCrateChange(e, index)}
                                                        components={{ Option: CustomOption }}
                                                        onBlur={(e) => checkError(creditDetailItem.ContainerID || '', index, 'ContainerID')}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <div className="position-relative input-icon">
                                                        <input
                                                            type="text"
                                                            className={`form-control input-sm text-end ps-4 input-width-110 ${errors[`CrateCreditAmt` + index] ? "is-invalid" : ''}`}
                                                            //value={!creditDetailItem.CrateCreditAmt ? 0 : parseFloat(creditDetailItem.CrateCreditAmt).toFixed(2)}
                                                            value={creditDetailItem.CrateCreditAmt || "0.00"}
                                                            placeholder="0.00"
                                                            onChange={(e) => {
                                                                setCreditDetails(prevCrateDetails => {
                                                                    const updatedCrateDetails = [...prevCrateDetails];
                                                                    updatedCrateDetails[index].CrateCreditAmt = formatPrice(e.target.value);
                                                                    return updatedCrateDetails;
                                                                });
                                                            }}
                                                            ref={el => creditEndInputRefs.current[index] = el}
                                                            onBlur={(e) => {
                                                                setCreditDetails(prevCrateDetails => {
                                                                    const updatedCrateDetails = [...prevCrateDetails];
                                                                    updatedCrateDetails[index].CrateCreditAmt = addTrailingZeros(e.target.value);
                                                                    return updatedCrateDetails;
                                                                });
                                                                checkError(parseInt(e.target.value), index, 'CrateCreditAmt');
                                                                addNewRow(index)
                                                            }}
                                                        />
                                                        <span className="text-lite cps-10 fs-14">$</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-inline-flex align-items-center justify-content-end flex-grow-1">
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleDelete(index)}
                                                            className={`text-decoration-none ${creditDetails.length - 1 === index ? 'd-none' : ''} `}
                                                        >
                                                            <i className="icon icon-delete ms-3 text-danger fw-bold"></i>
                                                        </div>
                                                    </div>
                                                </td>

                                            </tr>)
                                        })}
                                    </tbody>

                                </table>

                            </div>
                            {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
                            <div className="row d-flex justify-content-between align-items-end mt-2 mt-lg-0 pb-3">
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Items:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        value={creditDetails.length - 1}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Total:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        value={calculateTotalCredit()}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="col d-flex flex-column justify-content-between align-items-end mt-4 mt-lg-0">

                                <div className="d-flex">
                                    <button
                                        onClick={handlePreview}
                                        type="button"
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Preview
                                    </button>
                                    <button type="button"
                                        onClick={handleSave}
                                        disabled={creditDetails.length === 1}
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Save
                                    </button>
                                    <button type="button"
                                        onClick={() => { navigate("/veg-art") }}
                                        className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                                    >
                                        Exit
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment >
    )
}

export default CrateCredit
